import api from "@/http/api";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

const getAllCustomers = (page?: number, limit?: number, search?: string) => {
  const params = new URLSearchParams()
  if (page) params.append('page', page.toString())
  if (limit) params.append('limit', limit.toString())
  if (search) params.append('search', search)
  return api.get(`/admin/customer?${params.toString()}`);
};

export const useCustomer = (page?: number, limit = 20, enabled = true) => {
  return useQuery({
    queryKey: ["customers", page, limit],
    queryFn: async () => {
      return await getAllCustomers(page, limit);
    },
    enabled
  });
};

export const useInfiniteCustomer = (search: string, limit = 20, options?: { enabled?: boolean }) => {
  return useInfiniteQuery({
    queryKey: ['infinite-customers', search],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await getAllCustomers(pageParam, limit, search)
      return response.data
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage || !lastPage.pagination) return undefined;
      const { currentPage, totalPages } = lastPage.pagination;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    initialPageParam: 1,
    enabled: options?.enabled
  })
}
